import { render, staticRenderFns } from "./ContentBaseItem.vue?vue&type=template&id=1587918b&scoped=true&"
import script from "./ContentBaseItem.vue?vue&type=script&lang=js&"
export * from "./ContentBaseItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentBaseItem.vue?vue&type=style&index=0&id=1587918b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1587918b",
  null
  
)

export default component.exports